import { Dimensions, Platform, StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR, lightGrey } from 'utils/colors';
import {
    heightPercentageToDP,
    isTablet,
    isTabletOrWeb,
    landscapeAspectRatio,
    screenWidth,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    contentContainer: {
        marginTop: heightPercentageToDP(0, 85, 0),
        marginHorizontal: widthPercentageToDP(16, 44, 72),
        width: Platform.select({
            web: 520,
            default: isTablet ? 450 : undefined,
        }),
        height: Platform.select({
            web: heightPercentageToDP(400),
            default: isTablet ? 350 : screenWidth * 1.2,
        }),
        justifyContent: 'flex-end',
        zIndex: 2,
    },
    title: {
        fontFamily: Fonts.main.bold,
        fontSize: 24,
        lineHeight: 32,
        color: lightGrey(),
        textAlign: isTabletOrWeb ? 'left' : 'center',
        marginBottom: 10,
    },
    subtitle: {
        fontFamily: Fonts.main.bold,
        fontSize: 20,
        lineHeight: 24,
        color: lightGrey(),
        textAlign: isTabletOrWeb ? 'left' : 'center',
        marginBottom: 16,
    },
    description: {
        fontFamily: Fonts.main.regular,
        fontSize: 16,
        lineHeight: 24,
        textAlign: isTabletOrWeb ? 'left' : 'center',
        color: lightGrey(),
        marginBottom: 12,
    },
    buttonContainer: {
        flexWrap: 'wrap',
        alignContent: 'flex-start',
    },
    buttonText: {
        color: COLOR.BLACK,
    },
    root: {
        position: 'absolute',
        top: 0,
        left: 0,
    },
    image: {
        width: Dimensions.get('window').width,
        aspectRatio: landscapeAspectRatio,
    },
});

export default styles;
